import { render, staticRenderFns } from "./required_documents.vue?vue&type=template&id=7df23055&"
import script from "./required_documents.vue?vue&type=script&lang=js&"
export * from "./required_documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports